export default {
  colors: {
    text: "#34eb34",
    background: "#fff",
    primary: "#639",
    secondary: "#ff6347",
  },
}
